export default __webpack_public_path__ + "static/media/map.f63d5ff9.png";